import { render, staticRenderFns } from "./StoreDocuments.vue?vue&type=template&id=95b48aa4&scoped=true&"
import script from "./StoreDocuments.vue?vue&type=script&lang=js&"
export * from "./StoreDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StoreDocuments.vue?vue&type=style&index=0&id=95b48aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b48aa4",
  null
  
)

export default component.exports